import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { StandardOSOffer } from '../../models/offer-models/standard-os-offer.model';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Filter } from '../../models/filter.model';
import { RiskAssessment } from '../../models/offer-models/risk-assessment.model';
import { SimpleOffer } from '../../models/offer-models/simple-offer.model';

@Injectable({
    providedIn: 'root'
})
export class OfferService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/offers/' + id).toPromise();
    }

    getTop(filter: Filter) {
        return this.httpClient.post('api/offers/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.total;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/offers/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    boxView(filter: Filter) {
        return this.httpClient.post('api/offers/boxview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    simpleEditOffer(offer: SimpleOffer) {
        return this.httpClient.post('api/offers/simpleedit', offer.data).toPromise();
    }

    createDigitalOffer(standardOS: StandardOSOffer) {
        return this.httpClient.post('api/offers/create', standardOS.data).toPromise();
    }

    createProgresiveDigitalOffer(standardOS: any) {
        return this.httpClient.post('api/offers/create', standardOS).toPromise();
    }

    createProgress(standardOS: any) {
        return this.httpClient.post('api/offers/create', standardOS).toPromise();
    }

    createDraftOffer(standardOS: StandardOSOffer) {
        return this.httpClient.post('api/offers/createdraft', standardOS.data).toPromise();
    }

    createProgresivDraftOffer(standardOS: any) {
        return this.httpClient.post('api/offers/createdraft', standardOS).toPromise();
    }

    createFromDraftOffer(offerId: Number) {
        return this.httpClient.post('api/offers/finalizedraft', { OfferID: offerId }).toPromise();
    }

    editDraftOffer(standardOS: StandardOSOffer) {
        return this.httpClient.post('api/offers/editdraft', standardOS.data).toPromise();
    }

    editProgressiveDraftOffer(standardOS: any) {
        return this.httpClient.post('api/offers/editdraft', standardOS).toPromise();
    }

    sentSignRequest(offerId: Number) {
        return this.httpClient.post('api/offers/sendsignrequest', { OfferID: offerId }).toPromise();
    }

    checkOTPCode(offerId, token, code) {
        return this.httpClient.post('api/offers/checkotpcode', { OfferID: offerId, Token: token, OTPCode: code }).toPromise();
    }

    signOTPDocument(offerId, signer, docType, signature, signType) {
        return this.httpClient.post('api/offers/signdocuments', { OfferID: offerId, DocumentType: docType, Signer: signer, Signature: signature, SignType: signType }).toPromise();
    }

    signAgentOTPDocument(offerId, signer, docType, signature, signType) {
        return this.httpClient.post('api/offers/signdocumentsagent', { OfferID: offerId, DocumentType: docType, Signer: signer, Signature: signature, SignType: signType }).toPromise();
    }

    sendLocalDocuments(offerId) {
        return this.httpClient.post('api/offers/localSigningNotification', { OfferID: offerId }).toPromise();
    }

    previewDocument(offerId: Number, documentType: Number, signer: Number) {
        return this.httpClient.post('api/offers/previewdocuments', { OfferID: offerId, DocumentType: documentType, Signer: signer }, { observe: 'response', responseType: 'blob' }).toPromise();
    }

    createRiskAssessment(riskAssessment: RiskAssessment) {
        return this.httpClient.post('api/offers/createriskassessmentform', riskAssessment.data).toPromise();
    }

    getRiskAssessmentPdf(offerId: Number) {
        return this.httpClient.get('api/offers/downloadriskassessmentform/' + offerId, { observe: 'response', responseType: 'blob' }).toPromise();
    }
    changingStatus(statusObj: Object) {
        return this.httpClient.post('api/offers/changestatus', statusObj).toPromise();
    }

    changeIdentType(offerId: Number, type: String) {
        return this.httpClient.post('api/offers/changeidtype', { NewIDType: type, OfferID: offerId }).toPromise();
    }
    changeIdentStatus(offerId: Number, status: Boolean) {
        return this.httpClient.post('api/offers/changeidstate', { NewIDState: status, OfferID: offerId }).toPromise();
    }

    offersExcel(filter: Filter) {
        return this.httpClient.post('api/offers/excel', filter.data.Filter, { observe: 'response', responseType: 'blob' });
    }

}